import script from "./CancellingWebsiteWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./CancellingWebsiteWarning.vue?vue&type=script&setup=true&lang=js"

import "./CancellingWebsiteWarning.vue?vue&type=style&index=0&id=95f672d2&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95f672d2"]])

export default __exports__